module.exports = __webpack_public_path__ + "static/media/baseline-cloud_upload-24px.5fd570d0.svg";